import { render, staticRenderFns } from "./-menu.vue?vue&type=template&id=45a9dfc2&"
import script from "./-menu.vue?vue&type=script&lang=js&"
export * from "./-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports